document.addEventListener('DOMContentLoaded', function () {
  // Get the modal and video elements
var modal = document.getElementById('myModal');
//var video = document.getElementById('video-modal');
var video = modal.querySelector('video');

// Get the button that opens the modal
var btn = document.querySelector('button.button[aria-controls="myModal"]');


// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal
btn.onclick = function() {
  modal.style.display = "block";
  document.body.classList.add('modal-open');
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
  // Pause and reset the video
  video.pause();
  video.currentTime = 0;
  document.body.classList.remove('modal-open'); // Enable scrolling
}

modal.addEventListener('click', function(event) {
  // Check if the clicked element is the modal close button
  if (event.target.classList.contains('close')) {
      // Pause the video
      video.pause();
      document.body.classList.remove('modal-open'); // Enable scrolling
  }
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    // Pause and reset the video
    video.pause();
    video.currentTime = 0;
    document.body.classList.remove('modal-open'); // Enable scrolling
  }
}

});
